module.exports = __webpack_public_path__ + "assets/img/foreground.3715435a.png";